import React, { useState } from 'react';
import LogoForm from './LogoForm'
import { Paper, Grid, withStyles } from '@material-ui/core';
import History from "../../../History";
import * as Yup from "yup";
import * as actions from './store/logoActions';
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const LogoCreate = props => {
    const { classes, activeCustomer, translations, permissions, onCreateLogo } = props;
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '' });

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setFileToSend({ fileToSend: {}, fileName: '' });
            return
        }
        setFileToSend({ fileToSend: file, fileName: file.name, imageValue: URL.createObjectURL(file) });
    };

    const handleSubmit = async dataForm => {
        const data = new FormData();
        data.append("File", fileToSend.fileToSend);
        data.append("FileName", fileToSend.fileName);
        data.append("Name", dataForm.Name);
        data.append("ActiveCustomerID", activeCustomer);

        let token = localStorage.getItem("SESSION");

        data.append("Token", token);
        let result = await onCreateLogo(data);
        if (result) {
            History.goBack();
        }
    }

    let initialValues = {
        Name: ""
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
        },
        FormTitle: translations["create_logo"] || "Create logo",
        ButtonSubmit: hasPermission(permissions, "logo_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <LogoForm
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        loading={!fileToSend.fileName}
                        handleUpload={handleUpload}
                        translations={translations}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateLogo: logo => dispatch(actions.createLogo(logo))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LogoCreate));